var has = Object.prototype.hasOwnProperty;
module.exports = function assign(target, source) {
	if (Object.assign) {
		return Object.assign(target, source);
	}
	for (var key in source) {
		if (has.call(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/assign.js
// module id = 607
// module chunks = 168707334958949